import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const initialState = {
  homepageSessionId: undefined
};

const setHomepageSessionId = (draft, action) => {
  const {
    homepageSessionId
  } = action.payload;
  draft.homepageSessionId = homepageSessionId;
};

const homeSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setHomepageSessionId
  }
});
export const {
  actions
} = homeSlice;
export const plug = {
  [stateName]: homeSlice.reducer
};
export default homeSlice.reducer;